import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import useCurrentUserId from './useCurrentUserId';

const useRUCIdByCardTemplate = (cardTemplateId: string | undefined) : string => {
  const userId = useCurrentUserId();
  const rucDb = useSelector((state: RootState) => state.relationUserCardTemplateDb);
  const id = Object.keys(rucDb.relationUserCardTemplates).filter(id => {
    return rucDb.relationUserCardTemplates[id].cardTemplateId === cardTemplateId && rucDb.relationUserCardTemplates[id].userId === userId;
  })[0];

  return id;
}

export default useRUCIdByCardTemplate;
